import React from 'react'
import "./style.css";
import Services from '../../Components/Services/Services';
import HeaderText from '../../Components/HeaderText/HeaderText';
import Contact from '../Contact/Contact';
import OurWork from '../OurWork/OurWork';
import Product from '../Product/Product';
import SeoHead from '../../Components/SeoHead/SeoHead';

function Home() {
    return (
        <>
            <SeoHead
                path="/"
                description="Marmolería Colaiacovo: más de 60 años de experiencia en mármoles, granitos y cuarzos en Flores, Buenos Aires. Atención personalizada e instalación profesional."
            />
            <div id="homeContainer" className="container mx-auto max-w-100">
                <div className="block-main mx-auto max-w-6xl text-center">
                    <article id="home" className="background-container pt-10">
                        <HeaderText />
                    </article>
                    <div className="services-float">
                        <Services />
                    </div>

                    <article id="contact" className="contact-container" style={{backgroundColor: 'white', paddingBottom: '200px'}}>
                        <Contact />
                    </article>

                    <article id="nuestrosTrabajos" style={{backgroundColor: 'white', paddingBottom: '200px'}}>
                        <OurWork />
                    </article>

                    <article id="product" style={{backgroundColor: 'white', paddingBottom: '200px'}}>
                        <Product />
                    </article>
                </div>
            </div>
        </>
    );
}

export default Home;


